import {
    Component,
    EventEmitter,
    Injector,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { AppAuthService } from "@app/shared/common/auth/app-auth.service";
import { AppConsts } from "@shared/AppConsts";
import { AppComponentBase } from '@shared/common/app-component-base';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'congress-warn-modal',
  templateUrl: './congress-warn-modal.component.html',
  styleUrls: ['./congress-warn-modal.component.css']
})
export class CongressWarnModalComponent extends AppComponentBase implements OnInit  {
    @ViewChild("warnModal") modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    public title = '';
    public warnMessage = '';
    public showLogout = false;
    public gotoUrlOnClose = undefined;

    active = false;

    constructor(
        injector: Injector, private _authService: AppAuthService, private _router: Router
    ) {
        super(injector);
    }

    ngOnInit() {
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $("tabset ul.nav").addClass("m-tabs-line");
        $("tabset ul.nav li a.nav-link").addClass("m-tabs__link");
    }

    show(title: string, message: string, showLogout?: boolean, gotoUrlOnClose?: string): void {
        this.title = title;
        this.warnMessage = message;
        this.showLogout = showLogout;
        this.gotoUrlOnClose = gotoUrlOnClose;

        this.modal.show();

        this.active = true;
    }

    onShown() {}

    close(): void {
        this.active = false;
        this.modal.hide();
        if(this.gotoUrlOnClose){
            this._router.navigate([this.gotoUrlOnClose]);
        }
    }

    logout(){
        this._authService.logout(
            true,
            AppConsts.appBaseUrl + "/congresso/home"
        );
    }

}



// WEBPACK FOOTER //
// ./src/congress/shared/layout/congress-warn-modal/congress-warn-modal.component.ts